module.exports = __webpack_public_path__ + "static/media/dongtu2.980b793f.gif";